<template>
    <div class="row">
        <div v-for="(month, index) in term" class="c-month-cont col-md-6">
            <div class="c-month-title">{{dateToMonth(index)}}</div>
            <div class="c-week-days row m-0">
                <div class="c-week-day col p-0">{{trans('Mon')}}</div>
                <div class="c-week-day col p-0">{{trans('Tue')}}</div>
                <div class="c-week-day col p-0">{{trans('Wed')}}</div>
                <div class="c-week-day col p-0">{{trans('Thu')}}</div>
                <div class="c-week-day col p-0">{{trans('Fri')}}</div>
                <div class="c-week-day col p-0">{{trans('Sat')}}</div>
                <div class="c-week-day col p-0">{{trans('Sun')}}</div>
            </div>
            <div class="c-month-days row m-0">
                <div v-for="index in getFirstDayNumber(index)" class="c-month-day">
                    <div class="c-month-day-in"></div>
                </div>
                <div v-for="index in getDaysInMonth(index)" :class="ifDayInArray(index, month) ? 'c-month-day c-month-day-active' : 'c-month-day'">
                    <div class="c-month-day-in">{{index}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import moment from 'moment'
  moment.locale("en");

  export default {
    props: ['term'],
    data: function () {
      return {
        months: ["2021-01-01","2021-02-02"],
      }
    },
    methods: {
        getDaysInMonth(month){
            return moment(month).daysInMonth();
        },
        getFirstDayNumber(month){
            var month = +moment(month).startOf('month').format('d');
            if(month == 0){
                month = 6;
            }else{
                month = month -1;
            }
            return month;
        },
        dateToMonth(month){
            return moment(month).format('MMM Y');
        },
        ifDayInArray(day, array){
            var result = false;
            array.forEach((item) => {
                var new_day = Number(moment(item.date).format('DD'));
                if(Number(day) == new_day){
                    result = true;
                }
            });
            return result;
        }
    }
  }
</script> 

<style scoped>
.c-month-title {
    text-align: center;
    font-weight: bold;
    line-height: 30px;
}

.c-month-day {
    width: 14.2857143%;
    text-align: center;
    position: relative;
    color: #e3e3e3;
}

.c-week-day {
    text-align: center;
}

.c-month-day:before {
    content: "";
    display: block;
    padding-top: 100%;
}

.c-month-day-in {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    width: fit-content;
    height: fit-content;
}
.c-week-days {
    padding: 10px 0;
}
.c-month-day-active {
    border-radius: 50px;
    border: 5px solid white;
    color: black;
    font-weight: bold;
}
</style>